import { render, staticRenderFns } from "./BaseTableCollapsible.vue?vue&type=template&id=4f2a4a78&scoped=true"
import script from "./BaseTableCollapsible.vue?vue&type=script&lang=js"
export * from "./BaseTableCollapsible.vue?vue&type=script&lang=js"
import style0 from "./BaseTableCollapsible.vue?vue&type=style&index=0&id=4f2a4a78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2a4a78",
  null
  
)

export default component.exports